<div class="aplayer-volume-wrap">
  <vButton :type="`volume-${status}`" :icon="`volume-${status}`" @click="$emit('toggle')" :title="value > 0 ? '静音' : '取消静音'" />
  <Touch @panmove="changeHandler" :title="`${Math.round(currentValue * 100)}%`">
    <div class="aplayer-volume-bar-wrap" @click="changeHandler">
      <div class="aplayer-volume-bar" ref="bar">
        <div class="aplayer-volume" :style="{ height: `${currentValue * 100}%`, background: theme }"></div>
      </div>
    </div>
  </Touch>
</div>



// WEBPACK FOOTER //
// ./src/components/Volume/src/Volume.html